import PropTypes from 'prop-types';
import { Box, Text } from '@radix-ui/themes';
import BroadcastDayCell from './BroadcastDayCell.jsx';
import {
  getDaysInMonth,
  getFirstDayOfMonth,
  getBroadcastsForDay,
} from '../../../../campaigns/components/CampaignsTable/CalendarView/helpers.js';
import styles from '../../../../campaigns/components/CampaignsTable/CalendarView/CalendarView.module.css';

const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const EMPTY_LIST = [];
const noop = () => {};

export default function BroadcastMonthDetailView({
  monthIndex,
  year,
  broadcasts = EMPTY_LIST,
  onBroadcastClick = noop,
}) {
  const daysInMonth = getDaysInMonth(year, monthIndex);
  const firstDayOfWeek = getFirstDayOfMonth(year, monthIndex);

  const now = new Date();
  const isCurrentMonth =
    now.getFullYear() === year && now.getMonth() === monthIndex;
  const today = isCurrentMonth ? now.getDate() : null;

  // Create array of day cells including empty cells for padding
  const dayCells = [];

  // Add empty cells for days before the first day of the month
  for (let i = 0; i < firstDayOfWeek; i++) {
    dayCells.push({ type: 'empty', key: `empty-${i}` });
  }

  // Add cells for each day of the month
  for (let day = 1; day <= daysInMonth; day++) {
    const broadcastsForDay = getBroadcastsForDay(
      day,
      monthIndex,
      year,
      broadcasts,
    );
    const isPastDay = isCurrentMonth && day < today;

    dayCells.push({
      type: 'day',
      key: `day-${day}`,
      dayNumber: day,
      broadcasts: broadcastsForDay,
      isToday: day === today,
      isPastDay,
    });
  }

  return (
    <Box className={styles.monthDetailContainer}>
      <Box className={styles.monthDetailContent}>
        {/* Weekday headers */}
        <Box className={styles.weekdayHeader}>
          {WEEKDAYS.map(day => (
            <Text
              key={day}
              size="1"
              weight="medium"
              className={styles.weekdayLabel}
            >
              {day}
            </Text>
          ))}
        </Box>

        {/* Day grid */}
        <Box className={styles.monthDetailGrid}>
          {dayCells.map(cell => {
            if (cell.type === 'empty') {
              return <Box key={cell.key} className={styles.dayCellEmpty} />;
            }

            return (
              <BroadcastDayCell
                key={cell.key}
                dayNumber={cell.dayNumber}
                broadcasts={cell.broadcasts}
                isToday={cell.isToday}
                isPastDay={cell.isPastDay}
                onBroadcastClick={onBroadcastClick}
              />
            );
          })}
        </Box>
      </Box>
    </Box>
  );
}

BroadcastMonthDetailView.propTypes = {
  monthIndex: PropTypes.number.isRequired,
  year: PropTypes.number.isRequired,
  broadcasts: PropTypes.array,
  onBroadcastClick: PropTypes.func,
};
